// NATIVE

// INSTALLED
import { styled } from '@mui/material/styles';
import { Divider, Grid } from '@mui/material';
import TextAreaField from '../../formFields/TextAreaField';
import AutocompleteField from '../../formFields/autocompleteField';

// CUSTOM
import InputField from '../../formFields/InputField';
import { useSelector } from 'react-redux';

/**
 * CreateTipoNovedad component renders a form with multiple input fields and autocomplete fields.
 *
 * @param {any} props - The properties passed to the component.
 * @param {object} props.formField - The form fields object.
 * @param {object} props.formField.name - The name field configuration.
 * @param {object} props.formField.description - The description field configuration.
 * @param {object} props.formField.accion_1 - The first action field configuration.
 * @param {object} props.formField.resultado_1 - The first result field configuration.
 * @param {object} props.formField.cantidad_1 - The first quantity field configuration.
 * @param {object} props.formField.accion_2 - The second action field configuration.
 * @param {object} props.formField.resultado_2 - The second result field configuration.
 * @param {object} props.formField.cantidad_2 - The second quantity field configuration.
 * @param {object} props.formField.accion_3 - The third action field configuration.
 * @param {object} props.formField.resultado_3 - The third result field configuration.
 * @param {object} props.formField.cantidad_3 - The third quantity field configuration.
 * @param {object} props.formField.accion_4 - The fourth action field configuration.
 * @param {object} props.formField.resultado_4 - The fourth result field configuration.
 * @param {object} props.formField.cantidad_4 - The fourth quantity field configuration.
 *
 * @returns {JSX.Element} The rendered CreateTipoNovedad component.
 */
export const CreateTipoNovedad = (props: any) => {
  // USE SELECTOR
  const { actionTipoNovedadesSelect } = useSelector((state: any) => state.actionTipoNovedad);
  const { resultTipoNovedadesSelect } = useSelector((state: any) => state.resultTipoNovedad);

  // FORM FIELDS
  const {
    formField: {
      name,
      description,
      accion_1,
      resultado_1,
      cantidad_1,
      accion_2,
      resultado_2,
      cantidad_2,
      accion_3,
      resultado_3,
      cantidad_3,
      accion_4,
      resultado_4,
      cantidad_4,
    },
  } = props;

  const cantidad_list: any = [
    {
      label: '',
      value: 'SELECCIONAR',
    },
    {
      label: '1',
      value: '1',
    },
    {
      label: '2',
      value: '2',
    },
    {
      label: '3',
      value: '3',
    },
    {
      label: '4',
      value: '4',
    },
    {
      label: '5',
      value: '5',
    },
    {
      label: '6',
      value: '6',
    },
    {
      label: '7',
      value: '7',
    },
    {
      label: '8',
      value: '8',
    },
    {
      label: '9',
      value: '9',
    },
    {
      label: '10',
      value: '10',
    },
  ];

  return (
    <div>
      <div>
        <Grid container>
          <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
            <InputField
              name={name.name}
              label={name.label}
              variant="outlined"
              autoComplete="off"
              fullWidth
            />
          </Grid>
          <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
            <TextAreaField
              name={description.name}
              label={description.label}
              variant="outlined"
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={actionTipoNovedadesSelect}
              name={accion_1.name}
              label={accion_1.label}
              element={accion_1.name}
            />
          </Grid>

          <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={resultTipoNovedadesSelect}
              name={resultado_1.name}
              label={resultado_1.label}
              element={resultado_1.name}
            />
          </Grid>

          <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={cantidad_list}
              name={cantidad_1.name}
              label={cantidad_1.label}
              element={cantidad_1.name}
            />
          </Grid>

          <Divider />

          <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={actionTipoNovedadesSelect}
              name={accion_2.name}
              label={accion_2.label}
              element={accion_2.name}
            />
          </Grid>

          <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={resultTipoNovedadesSelect}
              name={resultado_2.name}
              label={resultado_2.label}
              element={resultado_2.name}
            />
          </Grid>

          <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={cantidad_list}
              name={cantidad_2.name}
              label={cantidad_2.label}
              element={cantidad_2.name}
            />
          </Grid>

          <Divider />

          <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={actionTipoNovedadesSelect}
              name={accion_3.name}
              label={accion_3.label}
              element={accion_3.name}
            />
          </Grid>

          <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={resultTipoNovedadesSelect}
              name={resultado_3.name}
              label={resultado_3.label}
              element={resultado_3.name}
            />
          </Grid>

          <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={cantidad_list}
              name={cantidad_3.name}
              label={cantidad_3.label}
              element={cantidad_3.name}
            />
          </Grid>

          <Divider />

          <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={actionTipoNovedadesSelect}
              name={accion_4.name}
              label={accion_4.label}
              element={accion_4.name}
            />
          </Grid>

          <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={resultTipoNovedadesSelect}
              name={resultado_4.name}
              label={resultado_4.label}
              element={resultado_4.name}
            />
          </Grid>

          <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={cantidad_list}
              name={cantidad_4.name}
              label={cantidad_4.label}
              element={cantidad_4.name}
            />
          </Grid>

          <Divider />
        </Grid>
      </div>
    </div>
  );
};
